@if (pages$ | async; as _pages) {
  <div class="side-nav">
    <div class="side-nav__wrapper" [ngClass]="{ 'slide-hide': openChildNav !== false }">
      <div class="site-logo">
        <a [core-analytics]="{ action: 'Home', category: 'SIDE-NAV' }" class="site-logo__link" routerLink="/">
          <img [src]="logoUrl | cdn" alt="{{ getSiteName() }}" class="site-logo__image" />
        </a>
      </div>
      @if (searchEnabled) {
        <core-search-form [autoFocus]="false" class="core-search-form--sidenav"></core-search-form>
      }
      <button
        (click)="hamburger = !hamburger; menuStateCheck(!hamburger)"
        [core-analytics]="{ action: 'Toggle menu', category: 'SIDE-NAV' }"
        class="hamburger hamburger--squeeze"
        type="button"
        [ngClass]="{ 'is-active': hamburger }"
        aria-label="Hamburger menu">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
      <!-- Not adding to DOM if we're showing the responsive menu -->
      @if (!isMobileNav) {
        <nav class="side-nav__menu" aria-label="Main navigation">
          <ul class="side-nav__menu-list">
            @for (page of _pages | orderBy: ['displayOrder']; track trackByFn($index)) {
              @if (showInMenu(page, 'no-child')) {
                <li class="side-nav__menu-item" [ngClass]="{ 'nav-item--posts': isDemoModeAndPostsLink(page) }">
                  @if (page.children.length === 0) {
                    <a
                      class="side-nav__menu-link"
                      [ngClass]="{ active: isCurrentPage(page) }"
                      [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                      [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url">
                      {{ page.name }}
                    </a>
                  }
                  @if (page.children.length > 0) {
                    <a
                      (click)="childNav(page)"
                      class="side-nav__menu-link side-nav__menu-link-has-children"
                      href="javascript:void(0);"
                      [core-analytics]="{
                        action: 'Toggle ' + page.name,
                        category: 'SIDE-NAV',
                      }">
                      {{ page.name }}
                    </a>
                  }
                </li>
              }
              <!-- ** REMOVE <li> FOR CLIENT BUILD **
              Split out <li> for 'posts' demo toggle purposes only. This can be removed for a client build -->
              @if (isDemoMode && page.url === 'articles' && postsEnabled) {
                <li class="side-nav__menu-item">
                  @if (page.children.length === 0) {
                    <a
                      class="side-nav__menu-link"
                      [ngClass]="{ active: isCurrentPage(page) }"
                      [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                      [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                      aria-current="page"
                      id="{{ page.url }}"
                      (click)="childNav(page.url)"
                      href="javascript:void(0)">
                      {{ page.name }}
                    </a>
                  }
                </li>
              }
            }
          </ul>
        </nav>
      }
      <core-side-nav-footer></core-side-nav-footer>
    </div>
    <div class="side-nav__children" [ngClass]="{ active: openChildNav !== false }">
      @if (openChildNav.name) {
        <h3 class="side-nav__children-heading">
          <a
            class="side-nav__children-back-link"
            href="javascript:void(0)"
            [core-analytics]="{ action: 'Back', category: 'SIDE-NAV' }"
            (click)="resetChildNav()"
            ><span></span>{{ 'Back' | translate }}</a
          >
        </h3>
      }
      <ul class="side-nav__child-menu-list">
        @for (page of openChildNav.children | orderBy: ['displayOrder', 'name']; track trackByFn($index)) {
          @if (page.meta.showInMenu === 'true' || page.meta.showInMenu === "'true'" || page.meta.showInMenu === true) {
            <li class="side-nav__child-menu-item">
              <a
                class="side-nav__child-menu-link"
                [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                [ngClass]="{ active: isCurrentPage(page) }"
                >{{ page.name }}</a
              >
            </li>
          }
        }
      </ul>
    </div>
    <!-- Not adding to DOM if we're showing the desktop sidenav menu -->
    @if (isMobileNav) {
      <div class="mobile-nav" [ngClass]="{ 'mobile-nav--active': hamburger }">
        <div class="mobile-nav__wrapper">
          @if (searchEnabled) {
            <core-search (closeSidenavHamburgerNav)="hamburger = !hamburger"></core-search>
          }
          <div class="side-nav__wrapper" [ngClass]="{ active: openChildNav !== false }">
            <!-- If search is needed, uncomment this out and ensure /search page in Core is not DRAFT -->
            <!-- <core-search (closeSidenavHamburgerNav)="closeResponsiveMenuOnSearch($event)"></core-search> -->
            <nav class="side-nav__menu" aria-label="Mobile navigation">
              <ul class="side-nav__menu-list">
                @for (page of _pages | orderBy: ['displayOrder']; track trackByFn($index)) {
                  @if (
                    page.meta.showInMenu === 'true' ||
                    page.meta.showInMenu === "'true'" ||
                    page.meta.showInMenu === true ||
                    page.name === 'home'
                  ) {
                    <li class="side-nav__menu-item">
                      @if (page.children.length === 0) {
                        <a
                          class="side-nav__menu-link"
                          (click)="hamburger = !hamburger"
                          [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                          [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                          [ngClass]="{ active: isCurrentPage(page) }">
                          {{ page.name }}
                        </a>
                      }
                      @if (page.children.length > 0) {
                        <a
                          (click)="childNav(page)"
                          [core-analytics]="{
                            action: 'Toggle ' + page.name,
                            category: 'SIDE-NAV',
                          }"
                          class="side-nav__menu-link side-nav__menu-link-has-children"
                          href="javascript:void(0);">
                          {{ page.name }}
                        </a>
                      }
                    </li>
                  }
                }
              </ul>
            </nav>
            <core-side-nav-footer></core-side-nav-footer>
          </div>
          <div
            class="side-nav__children"
            [ngClass]="{
              active: openChildNav !== false,
              'search-on': searchEnabled,
            }">
            @if (openChildNav.name) {
              <h3 class="side-nav__children-heading">
                <a
                  class="side-nav__children-back-link"
                  href="javascript:void(0)"
                  [core-analytics]="{ action: 'Back', category: 'SIDE-NAV' }"
                  (click)="resetChildNav()"
                  ><span></span>{{ 'Back' | translate }}</a
                >
              </h3>
            }
            <ul class="side-nav__children-list">
              @for (page of openChildNav.children; track trackByFn($index)) {
                @if (
                  page.meta.showInMenu === 'true' || page.meta.showInMenu === "'true'" || page.meta.showInMenu === true
                ) {
                  <li class="side-nav__children-item">
                    <a
                      class="side-nav__children-link"
                      (click)="resetChildNav(); hamburger = !hamburger"
                      [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                      [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                      >{{ page.name }}</a
                    >
                  </li>
                }
              }
            </ul>
          </div>
        </div>
      </div>
    }
  </div>
}
